import Vue from 'vue'
import VueRouter from 'vue-router'

// Views
import Company from '../../../components/view-company.vue';

Vue.use(VueRouter)

const Router = (options) => {
  return new VueRouter({
    mode: 'history',
    base: options.base,
    linkActiveClass: 'v-router-link__active',
    linkExactActiveClass: 'v-router-link__current',
    routes: [
      { path: '/', name: 'company', component: Company },
    ]
  })
}

export default Router;
